export default class ErrorObject {
  constructor(model) {
    this.model = model
  }

  hasError(fieldName) {
    const values = Object.values(this.errorsProps).filter((el) => !!el)
    const error = values.find((errorGroup) => {
      const { meta } = errorGroup
      if(meta && meta[fieldName]) {
        return true
      }
      return false
    })

    return !!error
  }

  getError(fieldName) {
    const values = Object.values(this.errorsProps).filter((el) => !!el)
    const errors = values.reduce((acc, errorGroup) => {
      const { meta } = errorGroup
      if(meta && meta[fieldName]) {
        return acc.concat(meta[fieldName])
      }
      return acc
    }, [])

    return errors.join(' ')
  }

  get errorsProps() {
    return this.model.props.errors || {}
  }
}